module.exports = __webpack_public_path__ + "9e4e0eed910f0686fc2b7ea7c72a5ba5.svg";